export function formatNumber(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) {
    return 0;
  }
  let val = num.toFixed(5).replace(",", ".");
  if (val.includes(".")) {
    val = val.replace(/(\.\d*?)0+$/, "$1");
    val = val.replace(/\.$/, "");
  }
  const parts = val.split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.length > 1 ? `${parts[0]}.${parts[1]}` : parts[0];
}
export function checkDolarDinar(from, amount, price_dolar) {
  var result = 0;
  //if from is 1 then convert from dinar to dollar
  if (from == 1) {
    //if to is 2 then convert from dinar to dollar
    result = amount / price_dolar;
  } else if (from == 2) {
    //if to is 1 then convert from dollar to dinar
    result = amount * price_dolar;
  }

  return result;
}
export function formatDate(value) {
  let date = new Date(value);

  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  //hours
  let hours = date.getHours();
  //minutes
  let minutes = date.getMinutes();
  //time zone
  //check if day is 1-9 then add 0 before day
  if (day < 10) {
    day = "0" + day;
  }
  //check if month is 1-9 then add 0 before month
  if (month < 10) {
    month = "0" + month;
  }

  return year + "-" + month + "-" + day + " " + hours + ":" + minutes;
}
